import api from "../client";
import { ENDPOINTS } from "../endpoints";

export interface UserConfigResponse {
  key: string;
  value: unknown;
}

export interface UserConfigsResponse {
  configs: Record<string, unknown>;
}

export const userConfigApi = {
  getAll: (): Promise<UserConfigsResponse> =>
    api.get<UserConfigsResponse>(ENDPOINTS.USER_CONFIGS),

  get: (key: string): Promise<UserConfigResponse> =>
    api.get<UserConfigResponse>(ENDPOINTS.USER_CONFIG(key)),

  save: (key: string, value: unknown): Promise<UserConfigResponse> =>
    api.put<UserConfigResponse>(ENDPOINTS.USER_CONFIG(key), { value }),

  delete: (key: string): Promise<void> =>
    api.delete<void>(ENDPOINTS.USER_CONFIG(key)),
};

export default userConfigApi;
